import type TabViewState from '../store/schema/TabViewState';
import { getStore } from '../store/tabStore';

export default function getTabById(tabId: string | null | undefined): TabViewState | null {
    if (tabId) {
        const store = getStore();
        for (const tab of store.tabs) {
            if (tab.id == tabId) {
                return tab;
            }
        }
    }

    return null;
}
